import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useMfaEnrollmentStatus } from './hooks/useMfaEnrollmentStatus';

export const MfaRestrictedRoute = ({ children }: { children: ReactElement }) => {
  const status = useMfaEnrollmentStatus();
  if (status?.isPastDeadline) {
    return <Navigate to="/" replace />;
  }
  return children;
};
